export const SET_WARRANTY_PAGE = 'SET_WARRANTY_PAGE';
export const SET_PATENT_PAGE = 'SET_PATENT_PAGE';
export const SET_TOS_PAGE = 'SET_TOS_PAGE';
export const SET_LEGAL_PAGES = 'SET_LEGAL_PAGES';
export const TERMS_ACCEPTED = 'TERMS_ACCEPTED';



// WEBPACK FOOTER //
// ./app/actions/legal.js